var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformacin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.48,
    height: 21.001,
    viewBox: "0 0 20.48 21.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#999;}.a{opacity:0;}.b{fill:none;stroke:#999;}.c{stroke:rgba(0,0,0,0);stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(0 0.001)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.833)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.349.007a9.559,9.559,0,0,0-8.286,14.35l-.626,5.3a.314.314,0,0,0,.312.352.32.32,0,0,0,.1-.016l4.763-1.6A9.572,9.572,0,1,0,10.349.007Z",
    transform: "translate(-0.776 -0.007)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,13.053A27.218,27.218,0,0,1,.8,9.213a27,27,0,0,0,.6-2.719.527.527,0,0,0-.028-.227c-.219,0-.563.527-.792.875-.094.143-.18.273-.253.37a.151.151,0,0,1-.25.011A.333.333,0,0,1,.031,7.18c.171-.364,1.706-3.558,2.7-3.558.479,0,1.03.159,1.03,1.386a23.916,23.916,0,0,1-.865,3.841,24.775,24.775,0,0,0-.71,3.015A5.159,5.159,0,0,0,3.7,10.9a.155.155,0,0,1,.238.057.34.34,0,0,1,0,.334c-1.132,1.917-2,3.026-3.067,3.026C.36,14.313,0,13.795,0,13.053ZM2.065,1.577C2.065.736,2.6,0,3.2,0S4.339.736,4.339,1.577,3.807,3.155,3.2,3.155,2.065,2.419,2.065,1.577Z",
    transform: "translate(7.136 2.565)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformacin);
export default __webpack_public_path__ + "static/media/información.99325472e1c88383a0885e152c7c373c.svg";
export { ForwardRef as ReactComponent };